/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="securityObject"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="displayPath" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="cmSearchPath" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="expression" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class SecurityFilter extends ObjectType{

	securityObject = null;

	expression = null;



	/**
	 * Gets the value of the securityObject property.
	 * @return {SecurityObject} possible object is {@link SecurityFilter.SecurityObject}
	 */
	getSecurityObject() {
		return this.securityObject;
	}

	/**
	 * Sets the value of the securityObject property.
	 * @param {SecurityObject} value allowed object is {@link SecurityFilter.SecurityObject}
	 */
	setSecurityObject(value) {
		var oldValue = this.securityObject;
		this.securityObject = value;
		this._setAndNotify(4, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the expression property.
	 * @return {String} possible object is {@link String}
	 */
	getExpression() {
		return this.expression;
	}

	/**
	 * Sets the value of the expression property.
	 * @param {String} value allowed object is {@link String}
	 */
	setExpression(value) {
		var oldValue = this.expression;
		this.expression = value;
		this._setAndNotify(5, oldValue, value, false, true);
	}

	/**
	 * Creates a new instance of <code>SecurityFilter</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> SecurityFilter</code> object from.
	 * @return {SecurityFilter} an object of type <code>SecurityFilter</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createSecurityFilter();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "SecurityFilter";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createSecurityFilterSecurityObject().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 4, "securityObject", clazz));
		featureList.push(this.createFeature(false, false, false, 5, "expression", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 4:
			this.setSecurityObject((value));
			break;
		case 5:
			this.setExpression((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 4:
			return this.getSecurityObject();
		case 5:
			return this.getExpression();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 4:
			return this.getSecurityObject();
		case 5:
			return this.getExpression();
		default:
			return super.basicGet(featureID);
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="displayPath" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="cmSearchPath" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
SecurityFilter.SecurityObject = class extends MoserObject{

	displayPath = null;

	cmSearchPath = null;



	/**
	 * Gets the value of the displayPath property.
	 * @return {String} possible object is {@link String}
	 */
	getDisplayPath() {
		return this.displayPath;
	}

	/**
	 * Sets the value of the displayPath property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDisplayPath(value) {
		var oldValue = this.displayPath;
		this.displayPath = value;
		this._setAndNotify(168, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cmSearchPath property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the cmSearchPath property. <p> For example, to add a new item, do as follows: <pre> getCmSearchPath().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getCmSearchPath() {
		if (!this.cmSearchPath) {
			this.cmSearchPath = [];
		}
		return this.cmSearchPath;
	}

	/**
	 * Gets the value of the <code>cmSearchPath</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetCmSearchPath() {
		return this.cmSearchPath;
	}

	/**
	 * Creates a new instance of <code>SecurityObject</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> SecurityObject</code> object from.
	 * @return {SecurityObject} an object of type <code>SecurityObject</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createSecurityFilterSecurityObject();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addCmSearchPathAt(position, item) {
		this._addAtAndNotify(this.getCmSearchPath(), position, item, 169, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addCmSearchPath(item) {
		this.addCmSearchPathAt(this.getCmSearchPath().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeCmSearchPathAt(position) {
		this._removeAtAndNotify(this.getCmSearchPath(), position, 169, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeCmSearchPath(item) {
		var i = this.getCmSearchPath().indexOf(item);
		if (i >= 0) {
			this.removeCmSearchPathAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "SecurityObject";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 168, "displayPath", null));
		featureList.push(this.createFeature(true, false, false, 169, "cmSearchPath", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 168:
			this.setDisplayPath((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 169:
			this.cmSearchPath = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 168:
			return this.getDisplayPath();
		case 169:
			return this.getCmSearchPath();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 168:
			return this.getDisplayPath();
		case 169:
			return this.basicGetCmSearchPath();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 169:
			this.addCmSearchPathAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 169:
			this.addCmSearchPath((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 169:
			this.removeCmSearchPathAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 169:
			this.removeCmSearchPath((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/SecurityFilter.js